module.exports = __webpack_public_path__ + "img/02.fc1e67b1.gif";